import './style.scss';
import SlideUp from '@components/slide-up';
import { BasicData } from '@App';

import { Trans } from '@lingui/macro';
import { useContext } from 'react';
import { getColor, getTextColorClass, addClickableLinks } from '@utils/Utils';
import { useIsMobile } from '@utils/hooks/useIsMobile';

const TermsAndConditionsComponent = () => {
    const { terms_and_conditions, branding, theme } = useContext(BasicData);

    const colors = getColor(theme);
    const mobile = useIsMobile();

    return (
        <div className="terms-and-conditions">
            <div className={`terms-and-conditions-main ${getTextColorClass(colors?.secondary)}`}>
                <h2><Trans>Terms and Conditions</Trans></h2>
            </div>
            {terms_and_conditions && (
                mobile ? (
                    <SlideUp header="Itinerary Terms and Conditions" className="itinerary-terms-and-conditions">
                        <div dangerouslySetInnerHTML={{ __html: addClickableLinks(terms_and_conditions) }} className="itinerary-terms-and-conditions" />
                    </SlideUp>
                ) : (
                    <>
                       <h4><Trans>Itinerary Terms and Conditions</Trans></h4>
                        <div dangerouslySetInnerHTML={{ __html: addClickableLinks(terms_and_conditions) }} className="break-words company-terms-and-conditions"/>
                    </>
                )
            )}
            {branding?.terms_and_conditions && (
                mobile ? (
                    <SlideUp header={branding?.company_name ? 'Terms and Conditions' : 'Company'} headerPrefix={branding?.company_name} className="company-terms-and-conditions">
                        <div dangerouslySetInnerHTML={{ __html: addClickableLinks(branding.terms_and_conditions) }} />
                    </SlideUp>
                ) : (
                    <>
                        <h4>{branding?.company_name ? `${branding?.company_name} ` : <Trans id="Company" values="Company" />}<Trans>Terms and Conditions</Trans></h4>
                        <div dangerouslySetInnerHTML={{ __html: addClickableLinks(branding.terms_and_conditions) }} className="break-words company-terms-and-conditions" />
                    </>
                )
            )}
        </div>
    )
}

export default TermsAndConditionsComponent;